export const SET_KANBAN_UI_FLAG = 'SET_KANBAN_UI_FLAG';
export const CLEAR_KANBANS = 'CLEAR_KANBANS';
export const SET_KANBANS = 'SET_KANBANS';
export const SET_KANBAN_ITEM = 'SET_KANBAN_ITEM';
export const EDIT_KANBAN = 'EDIT_KANBAN';
export const DELETE_KANBAN = 'DELETE_KANBAN';
export const SET_KANBAN_STAGE = 'SET_KANBAN_STAGE';
export const DELETE_KANBAN_STAGE = 'DELETE_KANBAN_STAGE';
export const SET_KANBAN_STAGE_AUTOMATION = 'SET_KANBAN_STAGE_AUTOMATION';
